import gql from 'graphql-tag';

import ImageFragment from './fragments/image';
import KioskImageFragment from './fragments/kiosk-image';

export default gql`
  query AllAppDataImages {
    allAppData(limit: 1) {
      _id
      loyaltyCardImage {
        locale: _LANG_ {
          ...ImageFragment
        }
      }
      loyaltyInfoImage {
        locale: _LANG_ {
          ...ImageFragment
        }
      }
      kioskAttractLoopImage {
        ...KioskImageFragment
      }
      kioskAttractLoopImageLocale {
        locale: _LANG_ {
          ...KioskImageFragment
        }
      }
    }
  }
  ${ImageFragment}
  ${KioskImageFragment}
`;
